export const environment = {
  production: false,
  version: '1.0',

  api: {
    host: 'https://core-api-dev.lab.avyna.io',
  },

  coreOnboarding: {
    host: 'https://core-onboarding-dev.lab.avyna.io',
  },
};
